const GrowpadConstant = {
  GROWPAD_SECRET: "AFE7DDFF45F5D96FA5AAF34C81C4A"
}

export default GrowpadConstant